import axios from 'axios';
import { PREFIX_URL } from './config';

const URLS = {}

URLS.BASE_URL = `${PREFIX_URL}/userActivity`;
URLS.DOCUMENT_LOG = `${PREFIX_URL}/v01/documentActivityLog`;

export const createDocumentLog = async(logData) => {
    const params = {
        type: 'file',
        data: logData
    };
    
    return await axios.post(URLS.BASE_URL, params)
    .catch(error => {
        console.log(error);
    });
}

export const fetchDocumentActivityLogs = async(params) => {     
    return await axios.get(URLS.DOCUMENT_LOG, {params})
      .then(res => res.data);
}
